import { render, staticRenderFns } from "./SwitchTyreIcon.vue?vue&type=template&id=04f76d6c&"
import script from "./SwitchTyreIcon.vue?vue&type=script&lang=js&"
export * from "./SwitchTyreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports